import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useWithholdTotalMutation = ({
	paidMonth,
	paidYear,
	onSuccessHandler,
}: {
	paidMonth: string;
	paidYear: string;
	onSuccessHandler?: () => void;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		values => {
			dispatch(uiActions.showSpinnerOverlay());
			return paymentsService.saveWithholdAgent({
				paidMonth,
				paidYear,
				values,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess: () => {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Withhold total value successfully saved",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useWithholdTotalMutation;
